import { api } from '../../lib/api';

export const TRANSFER_STATUSES = [
  { value: 'Draft', label: 'Draft', tone: 'neutral' },
  { value: 'Posted', label: 'Posted', tone: 'success' },
  { value: 'Cancelled', label: 'Cancelled', tone: 'danger' },
];

export const transferStatusMeta = (status) =>
  TRANSFER_STATUSES.find((s) => s.value === status) || { value: status, label: status, tone: 'neutral' };

function toQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const transfersApi = {
  list: (params = {}) => api.get(`/stock-transfers${toQuery(params)}`),
  get: (id) => api.get(`/stock-transfers/${id}`),
  // payload.post === true commits immediately; false saves a draft.
  create: (payload) => api.post('/stock-transfers', payload),
  post: (id) => api.post(`/stock-transfers/${id}/post`),
  cancel: (id, reason) => api.post(`/stock-transfers/${id}/cancel`, { reason: reason || null }),
};
